<template>
  <div class="container-md">
    <h1 class="page-header">Document Templates</h1>

    <DbTableControl :buttons="buttons"></DbTableControl>

    <div class="table table-sm">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Reference doc.</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td>
              <router-link class="d-block" :to="'/template/' + i.id">{{ i.name }}</router-link>
            </td>
            <td>{{ i.refdoc }}</td>
            <td>
              <span v-if="quote_default_template_id">
                <button
                  v-if="i.id == quote_default_template_id"
                  class="btn btn-primary qsys"
                  title="Default for new quotes"
                  disabled
                  style="opacity: 1;"
                >Q</button>
                <button
                  v-else
                  class="btn btn-light qsys text-muted"
                  style="cursor: pointer;"
                  @click="makeDefault(i.id)"
                  title="Make default for new quotes"
                >Q</button>
              </span>
              <button
                type="button"
                class="btn btn-default ml-4"
                title="Duplicate"
                @click="duplicate(i.id)"
              >
                <i class="fa fa-copy"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";
import { createWhereTextSearch } from "../lib/sql.js";
import dbTableMixin from "../lib/dbtable-mixin";
import DbTableControl from "../components/DbTableControl";

export default {
  mixins: [dbTableMixin],
  components: {
    DbTableControl,
  },
  data() {
    return {
      buttons: [
        {
          to: "/template",
          text: "Add template",
          accesskey: "a",
          fa: "plus",
        },
      ],
      items: [],
      user: null,
      quote_default_template_id: null,
    };
  },
  methods: {
    makeDefault(id) {
      authFetch("/setting/quote_default_template_id", {
        method: "put",
        body: id,
      }).then(() => this.load());
    },
    duplicate(id) {
      authFetch(`/db/template/${id}`)
        .then((resp) => resp.json())
        .then((item) => {
          delete item.id;
          for (var i = 1; this.items.find((x) => x.name === item.name); i++) {
            item.name = `${item.name} (${i})`;
          }
          authFetch("/db/template", {
            method: "post",
            body: JSON.stringify(item),
          }).then(() => this.load());
        });
    },
    load() {
      let uri = "/db/template?select=id,name,refdoc&sort=name";
      if (this.searchtext) {
        uri +=
          "&where=" +
          encodeURIComponent(createWhereTextSearch(this.searchtext, ["name"]));
      }
      authFetch(uri)
        .then((resp) => resp.json())
        .then((data) => (this.items = data));
      authFetch("/setting/quote_default_template_id")
        .then((resp) => resp.json())
        .then(
          (data) =>
            (this.quote_default_template_id = parseInt(
              data.quote_default_template_id
            ))
        );
    },
  },
};
</script>